"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var disableInboxRuleRequest_1 = require("owa-service/lib/factory/disableInboxRuleRequest");
var disableInboxRuleOperation_1 = require("owa-service/lib/operation/disableInboxRuleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Helper method that creates the DisableInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return DisableInboxRuleRequest
 */
function createRequestBody(inboxRule) {
    return disableInboxRuleRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Identity: inboxRule.Identity,
    });
}
/**
 * Disable inbox rule service
 * @param inboxRule the inbox rule
 * @return DisableInboxRuleResponse
 */
function disableInboxRuleService(inboxRule) {
    var requestBody = createRequestBody(inboxRule);
    return disableInboxRuleOperation_1.default(requestBody);
}
exports.default = disableInboxRuleService;
//# sourceMappingURL=disableInboxRuleService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/disableInboxRuleService.js
// module id = 5167
// module chunks = 2